import { participantDashboardService } from "../service";
import { participantIctListService } from "../service/participantIctList.service";
import {
  setParticipantDashboardLoading,
  setParticipantDashboardData,
  setParticipantDashboardError,
} from "../slice/participantDashboardSlice";

const getRecentListAsync = (service) => async (dispatch) => {

  dispatch(setParticipantDashboardLoading())
  try {
    const response = await participantDashboardService.getRecentList(service);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setParticipantDashboardError(response));
      dispatch(setParticipantDashboardData({}));
    } else {
      dispatch(setParticipantDashboardData(response?.data));
      dispatch(setParticipantDashboardError({}));
    }
  } catch (error) {
    dispatch(setParticipantDashboardError(error));
  }
};
const getInventoryListAsync = (page, limit, filter, t) => async (dispatch) => {

  dispatch(setParticipantDashboardLoading())
  try {
    const response = await participantDashboardService.getInventoryList(page, limit, filter);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setParticipantDashboardError(response));
      dispatch(setParticipantDashboardData({}));
    } else {
      dispatch(setParticipantDashboardData(response?.data));
      dispatch(setParticipantDashboardError({}));
    }
  } catch (error) {
    dispatch(setParticipantDashboardError(error));
  }
};

const getEvaluationListAsync = (page, limit, filter, t) => async (dispatch) => {

  dispatch(setParticipantDashboardLoading())
  try {
    const response = await participantDashboardService.getEvaluationList(page, limit, filter);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setParticipantDashboardError(response));
      dispatch(setParticipantDashboardData({}));
    } else {
      dispatch(setParticipantDashboardData(response?.data));
      dispatch(setParticipantDashboardError({}));
    }
  } catch (error) {
    dispatch(setParticipantDashboardError(error));
  }
};

const getFollowupListAsync = (page, limit, filter, t) => async (dispatch) => {

  dispatch(setParticipantDashboardLoading())
  try {
    const response = await participantDashboardService.getFollowupList(page, limit, filter);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setParticipantDashboardError(response));
      dispatch(setParticipantDashboardData({}));
    } else {
      dispatch(setParticipantDashboardData(response?.data));
      dispatch(setParticipantDashboardError({}));
    }
  } catch (error) {
    dispatch(setParticipantDashboardError(error));
  }
};
// ICT actions
const getIctInventoryListAsync = (page, limit, filter, inventory_code) => async (dispatch) => {
  dispatch(setParticipantDashboardLoading())
  try {
    const response = await participantIctListService.getIctInventoryList(page, limit, filter, inventory_code);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setParticipantDashboardError(response));
      dispatch(setParticipantDashboardData({}));
    } else {
      dispatch(setParticipantDashboardData(response?.data));
      dispatch(setParticipantDashboardError({}));
    }
  } catch (error) {
    dispatch(setParticipantDashboardError(error));
  }
};

const getIctEvaluationListAsync = (page, limit, filter, t) => async (dispatch) => {

  dispatch(setParticipantDashboardLoading())
  try {
    const response = await participantIctListService.getIctEvaluationList(page, limit, filter);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setParticipantDashboardError(response));
      dispatch(setParticipantDashboardData({}));
    } else {
      dispatch(setParticipantDashboardData(response?.data));
      dispatch(setParticipantDashboardError({}));
    }
  } catch (error) {
    dispatch(setParticipantDashboardError(error));
  }
};

const getIctFollowupListAsync = ( page, limit, filter, t) => async ( dispatch) => {
  dispatch(setParticipantDashboardLoading())
  try {
    const response = await participantIctListService.getIctFollowupList(page, limit, filter);
    if (response?.data?.error || response?.data?.Error) {
      dispatch(setParticipantDashboardError(response));
      dispatch(setParticipantDashboardData({}));
    } else {
      dispatch(setParticipantDashboardData(response?.data));
      dispatch(setParticipantDashboardError({}));
    }
  } catch (error) {
    dispatch(setParticipantDashboardError(error));
  }
};

export const ParticipantDashboardAction = {
  getRecentListAsync,
  getInventoryListAsync,
  getEvaluationListAsync,
  getFollowupListAsync,
  getIctInventoryListAsync,
  getIctEvaluationListAsync,
  getIctFollowupListAsync,
};
